import React from 'react'

const MessageAlert = ({ message, type, onClose }) => {
  if (!message) return null

  return (
    <div className={`mb-6 p-4 rounded-xl border ${
      type === 'success'
        ? 'bg-green-500/10 border-green-500/20 text-green-200'
        : 'bg-red-500/10 border-red-500/20 text-red-200'
    }`}>
      {message}
    </div>
  )
}

export default MessageAlert